import Icon from '../components/Icon.vue'

Icon.register({
  'file-contract': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M224 136c0 13.2 10.8 24 24 24h136v328c0 13.3-10.7 24-24 24h-336c-13.3 0-24-10.7-24-24v-464c0-13.3 10.7-24 24-24h200v136zM64 72v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zM64 136v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zM256.8 384c-4.2 0-8.1-2.4-10.2-6.5-12-23.9-46.2-30.3-66-14.2l-13.9-41.6c-3.3-9.8-12.4-16.4-22.8-16.4s-19.5 6.6-22.8 16.4l-18.2 54.6c-1.5 4.6-5.8 7.7-10.6 7.7h-12.4c-8.8 0-16 7.2-16 16s7.2 16 16 16h12.4c18.6 0 35.1-11.9 41-29.5l10.6-31.9 16.8 50.5c2 6.1 7.6 10.4 14 10.9 0.4 0 0.8 0 1.1 0h0c5.5 0 11.9-4 14.3-8.8l7.7-15.3c2.8-5.6 7.9-6.2 10-6.2s7.2 0.6 10.2 6.5c7.4 14.7 22.2 23.9 38.6 23.9h47.2c8.8 0 16-7.2 16-16s-7.2-16-16-16h-47.2zM377 105c4.5 4.5 7 10.6 7 16.9v6.1h-128v-128h6.1c6.4 0 12.5 2.5 17 7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-contract.js
// module id = 1331
// module chunks = 0